<template>
  <tr
    v-if="!dataRow.isHide"
    :class="[
      'ms-tr ms-tr-grid-viewer',
      isUseDataRowStyle && dataRow.IsBold ? 'ms-format-bold' : '',
      isUseDataRowStyle && dataRow.IsItalic ? 'ms-format-italic' : '',
      isUseDataRowStyle && dataRow.is_bold ? 'ms-format-bold' : '',
      isUseDataRowStyle && dataRow.is_italic ? 'ms-format-italic' : '',
      isUseDataRowStyle && dataRow.is_capital ? 'ms-format-capital' : '',
      {'action-hover': showRowAction && actionInline},
      {'rowspan-group': dataRow[`rowspan-${groupField[0]}`]},
    ]"
    :data-rowspan-group="getRowSpanGroupId()"
    tabindex="0"
    :indexRow="dataRow.rowIndex || index"
    @keydown="row_keydown"
  >
    <td
      v-if="multiple && dataRow[`rowspan-${groupField[0]}`]"
      class="ms-td multiple-cell sticky ms-col-td-multiple"
      :rowspan="dataRow[`rowspan-${groupField[0]}`] || 1"
    >
      <ms-checkbox
        ref="multiple"
        :key="0"
        :checked="isChecked"
        class="justify-center"
        check-only
        :disabled="disabledCheckedMultipleTbody || disabled"
        @input="checkMultiple"
      />
    </td>
    <td
      v-if="serial && dataRow[`rowspan-${groupField[0]}`]"
      :key="0"
      :rowspan="dataRow[`rowspan-${groupField[0]}`] || 1"
      class="ms-td serial text-center"
      :class="{sticky: hasLockColumn}"
    >
      {{ pageSize * (currentPage - 1) + index + 1 }}
    </td>
    <td
      v-for="(col, index) in columnx"
      :key="col.dataField"
      :ref="`td-${col.dataField}`"
      class="ms-td ms-col-td"
      :class="[
        col.cssCellClass,
        {sticky: col.lock},
        index === columnx?.length - 1 && columns.length === columnx.length ? 'ms-col-td-last' : '',
      ]"
      :style="styleWidth(col, false)"
      :rowspan="dataRow[`rowspan-${col.dataField}`]"
    >
      <component
        :is="col.template"
        v-if="col.template"
        :data="dataRow"
        :column="col"
        :data-row="dataRow"
        :col="col"
        :row-selected="rowSelected"
        :is-selected="isSelected"
      />
      <div v-else-if="col.isSerial" :class="[`justify-center`, col.cssClass]">
        <span>{{ index + 1 }}</span>
      </div>

      <!-- Kiểu Text nhưng có dạng nhiều dòng value= MORE_DETAILS-->
      <div
        v-else-if="dataRow[col.dataField] === 'MORE_DETAILS'"
        :class="[`text-${col.align || 'left'}`, col.cssClass, 'text-overflow', 'icon24', 'more-rows']"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        @click="viewMoreDetails(col, dataRow)"
      >
        <span />
      </div>
      <div
        v-else
        :class="[
          `text-${col.align || 'left'}`,
          col.cssClass,
          'text-overflow',
          $ms.constant.FormatType.Checkbox,
          col.formatType,
        ]"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
      >
        <!-- v-tooltip="{ content:titleToolTip(dataRow, col), placement: 'top'}" -->
        <!-- kiểu checkbox -->
        <span
          v-if="col.formatType === $ms.constant.FormatType.Checkbox"
          :ref="`text-${col.dataField}`"
          class="cell-checkbox"
        >
          <div class="icon" :class="{checked: dataRow[col.dataField]}" />
        </span>
        <!-- kiểu html -->
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.Html"
          class="customStyleHtml"
          v-html="dataRow[col.dataField]"
        />
        <span v-else :ref="`text-${col.dataField}`" :class="[`text-${col.align || 'left'}`]">
          {{
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
            })
          }}
        </span>

        <!-- <div
          :class="['mi', 'mi-24', col.icon.type]"
          v-if="col.icon && col.icon.show(dataRow, col)"
          v-tooltip="{ ...col.icon.tooltip }"
        ></div> -->
      </div>
    </td>
    <td
      v-if="$slots.widget && dataRow[`rowspan-${groupField[0]}`]"
      :key="100"
      class="ms-td widget-item sticky"
      :rowspan="dataRow[`rowspan-${groupField[0]}`] || 1"
    >
      <slot name="widget" />
    </td>
  </tr>
</template>
<script>
export default {
  name: 'MsTr',
  components: {},
  props: {
    // Lưu thông tin của các cột
    columns: {},
    // Lưu dữ liệu của dòng
    dataRow: {},
    // Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    // Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    index: {
      default: null,
      type: Number,
    },
    serial: {
      default: false,
      type: Boolean,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    pageSize: {
      default: 20,
      type: Number,
    },
    rowSelected: {
      default: null,
    },
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    actionInlineCount: {
      type: Number,
    },
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    groupField: {
      default: () => [],
      type: Array,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    /**
     * Check có sử dụng style của dữ liệu không
     * NMDUC1 16/10/2023
     */
    isUseDataRowStyle: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      /**
       * Hiển thị row action không
       */
      showRowAction: false,
      /**
       * Style đặt vị trí hiển thị row action
       */
      rowActionStyle: {
        top: 0,
        left: 0,
      },
    };
  },
  computed: {
    /**
     * Action hiển thị trên dòng chọn ngay
     */
    actionInline() {
      const result = [];
      const actions = this.rowActions;

      if (actions) {
        if (actions.length > this.actionInlineCount) {
          for (let i = 0; i < this.actionInlineCount - 1; i++) {
            result.push(actions[i]);
          }

          result.push({
            command: 'MORE',
            icon: 'more',
            text: this.moreText,
          });
        } else {
          for (let i = 0; i < actions.length; i++) {
            result.push(actions[i]);
          }
        }
      }

      return result;
    },
    /**
     * Action hiển trong more context
     */
    actionContext() {
      const result = [];
      const actions = this.rowActions;

      if (actions && actions.length > this.actionInlineCount) {
        for (let i = this.actionInlineCount - 1; i < actions.length; i++) {
          result.push(actions[i]);
        }
      }

      return result;
    },
    /**
     * Nếu có check all sẽ thực hiện check all
     */
    isChecked() {
      const {disabledCheckedMultipleTbody, isCheckedAll, isSelected} = this;
      return disabledCheckedMultipleTbody ? false : isCheckedAll || isSelected;
    },

    columnx() {
      const columns = this.columns.filter(column => {
        if (this.groupField.includes(column.dataField)) {
          if (this.dataRow[`rowspan-${column.dataField}`]) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      return columns;
    },
  },
  created() {
    const me = this;
    me.moreText = me.$t('i18nCommon.Command.More');
  },
  methods: {
    /**
     * Lấy ID nhóm row span để áp dụng hover/select cho toàn bộ group
     */
    getRowSpanGroupId() {
      const me = this;
      if (me.groupField && me.groupField.length > 0) {
        return me.tieredGroup
          ? me.dataRow[me.groupField[0]]
          : me.groupField.map((x) => me.dataRow[x]).join('=+*');
      }
      return null;
    },
  
      /**
     * Xử lý khi hover vào row
     */
    handleMouseEnter() {
      const me = this;
      const groupId = me.getRowSpanGroupId();
      if (groupId) {
        // Thêm class hover cho tất cả rows trong cùng group
        const rows = document.querySelectorAll(
          `tr[data-rowspan-group="${groupId}"]`
        );
        rows.forEach((row) => {
          row.classList.add('rowspan-group-hover');
        });
      }
    },

    /**
     * Xử lý khi mouse rời khỏi row
     */
    handleMouseLeave() {
      const me = this;
      const groupId = me.getRowSpanGroupId();
      if (groupId) {
        // Xóa class hover cho tất cả rows trong cùng group
        const rows = document.querySelectorAll(
          `tr[data-rowspan-group="${groupId}"]`
        );
        rows.forEach((row) => {
          row.classList.remove('rowspan-group-hover');
        });
      }
    },
    // Cập nhật lại độ rộng của cột theo độ rộng cấu hình
    // Created by LTDAT
    styleWidth(col, widget) {
      const rs = {};

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      if (!widget) {
        rs['max-width'] = col.width + 'px';
      }
      this.$emit('styleColumn', col, this.dataRow, rs);

      return rs;
    },

    drilldownClick(col, dataRow, e) {
      const metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('drilldownClick', metaData, e);
    },

    // (Click vào các cột có dạng số nhiều.(đại diện cho nhiều dòng chi tiết)
    // Created by TVLOI 22.05.2021
    viewMoreDetails(col, dataRow, e) {
      dataRow.moreDetails = true;
      const metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('viewMoreDetails', metaData, e);
    },

    // Emit sự kiện ấn phím ra ngoài grid
    // Created by LTDAT(13/06/2020)
    row_keydown(e) {
      const me = this;
      me.$emit(me.$ms.constant.CustomEvent.MsKeydown, me.dataRow, e);
    },
    // Sự kiện click vào nút chọn ở cột multiple
    // Created by LTDAT (28.05.2020)
    // NCPHUOC 28/03/2022: emit checkbox event ra ngoài grid
    checkMultiple(e) {
      const me = this;
      const checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      me.$emit('clickMultiple', me.dataRow, checked);
    },

    /**
     * Show tooltip cho nội dung cell
     */
    titleToolTip(dataRow, col) {
      return '';
    },
    /**
     * convert html code to text
     */
    stripHtml(source) {
      let output;
      source = source.toString();
      // get rid of HTML tags
      output = source.replace(/<[^>]*>/g, '');
      output = output.replace(/&nbsp;/g, ' ');
      output = output.replace(/\n/g, '; ');
      return output;
    },
    showActionSub(action, event) {
      const me = this;
      if (action.subMenu) {
        let liPersent = event.toElement;
        if (liPersent) {
          while (!liPersent.className.contains('actionSub')) {
            liPersent = liPersent.offsetParent;
          }
          const liPosition = liPersent.getBoundingClientRect(); // Position của thẻ li (action cha)
          const [menuSub] = me.$refs.actionSubMenu; // Position menu sub
          const elSub = menuSub.$el; // element sub
          const elSubPosition = menuSub.$el.getBoundingClientRect(); // Position của menusub
          if (elSub) {
            // gán lại style cho  element sub, đang tạm gán thôi, chưa tính trường hợp dàn lên trên nếu top quá to hoặc dàn sang phải nếu left quá nhỏ
            elSub.style.top = liPosition.top + 'px';
            elSub.style.left = liPosition.left - elSubPosition.width + 'px';
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrViewer.scss';
tr.rowspan-group {
  td.sticky {
    z-index: 1;
  }
}

.ms-format-bold {
  font-weight: $font-weight-bold;
}
.ms-format-italic {
  font-style: italic;
}
</style>
